export default function HorizontalLine({ width = '70%' }) {
  return (
    <>
      <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
        <svg width={width} height='2' viewBox='0 0 1206 2' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            vectorEffect='non-scaling-stroke'
            d='M0 1.00024L914.475 1.00016L1206 1.00014'
            stroke='url(#paint0_linear_237_845)'
            strokeWidth='2'
          />
          <defs>
            <linearGradient id='paint0_linear_237_845' x1='0' y1='1.00024' x2='1226.84' y2='16.6779' gradientUnits='userSpaceOnUse'>
              <stop stopColor='#BC9C4E' stopOpacity='0' />
              <stop offset='0.5' stopColor='#BC9C4E' />
              <stop offset='1' stopColor='#BC9C4E' stopOpacity='0' />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </>
  );
}
